import type { Register } from '../profile/register';

/**
 * The line of IPA a surface draws, or `null` for none.
 *
 * IPA aid spec §2: adults only, on both surfaces — a correction is kept from a
 * child already, and a word a child asked about is better served by "Hear it"
 * than by a notation they rarely read. A function rather than a JSX condition
 * so the gate is tested.
 */
export function pronunciationFor(ipa: readonly string[] | null | undefined, register: Register): string | null {
  if (register !== 'adult' || !ipa || ipa.length === 0) return null;
  return ipa.join(' · ');
}
